/// スクロール位置によって何かする
(function(global) {
	"use strict";

	var isStarted = false
	, observers = {}
	, maxId = 1
	, resizeTimer
	;
	
	function register(direction, calcFunc, callback) {
		if (!/^[xy]$/.test(direction)) return false;
		
		observers[maxId] = {
			direction: direction
			, calc: calcFunc
			, callback: callback
			, points: []
		};
		maxId++;
		return maxId - 1;
	}

	function start() {
		calcPoints();
		if (!isStarted) {
			window.addEventListener("scroll", scrollHandler); // Explorer, Chrome, Opera
			document.addEventListener("scroll", scrollHandler); // Firefox
			window.addEventListener("resize", resizeHandlerDelayed);
		}
	}

	function calcPoints() {
		var i, observer;
		for (i in observers) {
			observer = observers[i];
			observer.points = observer.calc();
		}
		scrollHandler();
	}

	function resizeHandlerDelayed() {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(resizeHandler, 200);
	}
	
	function resizeHandler() {
		calcPoints();
	}

	function scrollHandler() {
		var scroll, i, observer, dir, j, point;
		scroll = {
			x: window.scrollX || window.pageXOffset || (document.documentElement || document.body.parentNode || document.body).scrollLeft
		,	y: window.scrollY || window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop
		};
		for (i in observers) {
			observer = observers[i];
			dir = observer.direction;
			for (j = observer.points.length - 1; j >= 0; j--) {
				point = observer.points[j];
				if (scroll[dir] >= point[dir]) {
					observer.callback(point.name);
					break;
				}
			}
			if (j < 0) {
				observer.callback(null);
			}
		}
	}

	// Expose
	global.ScrollSwitch = {
		register: register,
		start: start,
	};
	
})(window);
